<template>
  <ul class="space-y-2">
    <li
      v-for="(service, idx) in servicesList"
      :key="idx"
      class="flex items-center space-x-2"
    >
      <span :class="serviceIconClass(service.state)">
        <component
          :is="serviceIcons[service.state]"
          v-if="serviceIcons[service.state]"
          class="h-4 w-4"
        />
      </span>
      <p class="text-text-neutral-secondary text-sm">{{ service.name }}</p>
    </li>
  </ul>
</template>

<script setup lang="ts">
  import { defineAsyncComponent, type Component } from 'vue';
  import type { Airflow } from '@aviata/platform-types';

  import { FF_SERVICE_STATE } from '@/entities/fare';

  defineProps<{
    servicesList?: Airflow.FareFamily.Description.Entity[];
  }>();

  const serviceIconLoaders: Record<string, () => Promise<Component>> = {
    [FF_SERVICE_STATE.NOT_OFFER]: () =>
      import('@/assets/images/fare/excluded.svg?component'),
    [FF_SERVICE_STATE.INCLUDED]: () =>
      import('@/assets/images/fare/included.svg?component'),
    [FF_SERVICE_STATE.CHARGEABLE]: () =>
      import('@/assets/images/fare/chargeable.svg?component'),
  };

  const serviceIconClassMap: Record<string, string> = {
    [FF_SERVICE_STATE.NOT_OFFER]: 'text-background-negative-primary',
    [FF_SERVICE_STATE.INCLUDED]: 'text-background-positive-primary',
    [FF_SERVICE_STATE.CHARGEABLE]: 'text-situational-darkgrey',
  };

  const serviceIcons: Record<string, Component> = Object.fromEntries(
    Object.entries(serviceIconLoaders).map(([state, loader]) => [
      state,
      defineAsyncComponent(loader),
    ]),
  );

  const serviceIconClass = (state: string): string => {
    return serviceIconClassMap[state] || 'text-situational-darkgrey';
  };
</script>
